(() => {
  if (customElements.get('savour-signup')) return;
  class SavourSignup extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.dialog = this.querySelector('dialog');
      this.tab = this.querySelector('[data-signup-open]');
      if (!this.dialog || !this.dialog.showModal) return;
      this.preview = new URLSearchParams(location.search).get('savour_signup') === 'preview';
      this.editor = this.dataset.editor === 'true';
      this.key = 'savour:signup:v1';
      this.opened = false;
      this.started = Date.now();
      this.delay = Number(this.dataset.delay || 12) * 1000;
      this.readState = () => { try { return JSON.parse(localStorage.getItem(this.key) || '{}'); } catch (_) { return {}; } };
      this.writeState = (state) => { try { localStorage.setItem(this.key, JSON.stringify(state)); } catch (_) {} };
      this.state = this.readState();
      this.signedUp = Boolean(this.querySelector('[data-signup-success]'));
      this.formError = Boolean(this.querySelector('[data-signup-error]'));
      if (this.signedUp) this.writeState({ subscribed: true, at: Date.now() });
      this.querySelectorAll('[data-signup-close]').forEach(button => button.addEventListener('click', () => this.dismiss(), { signal }));
      this.tab.addEventListener('click', () => this.open(true), { signal });
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(); }, { signal });
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('sl-signup-open'), { signal });
      this.querySelector('[data-copy-code]')?.addEventListener('click', async event => {
        const button = event.currentTarget;
        try {
          await navigator.clipboard.writeText(button.dataset.copyCode);
          button.querySelector('[data-copy-feedback]').textContent = this.dataset.copiedLabel;
        } catch (_) {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(button.querySelector('strong'));
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }, { signal });
      document.addEventListener('shopify:section:select', event => {
        if (event.detail?.sectionId === this.dataset.sectionId) this.open(true);
      }, { signal });
      if (this.signedUp || this.formError || this.preview || this.editor) {
        this.open(true);
        return;
      }
      if (this.state.subscribed) return;
      this.tab.hidden = false;
      const dismissedUntil = Number(this.state.dismissedUntil || 0);
      if (dismissedUntil > Date.now()) return;
      const engage = () => {
        const distance = Math.max(document.documentElement.scrollHeight - innerHeight, 1);
        if (scrollY > 160 && scrollY / distance >= 0.12 && Date.now() - this.started >= this.delay) this.open();
      };
      window.addEventListener('scroll', engage, { passive: true, signal });
      this.timer = window.setTimeout(engage, this.delay);
      document.addEventListener('mouseout', event => {
        if (event.relatedTarget || event.clientY > 0 || !matchMedia('(pointer:fine)').matches) return;
        if (Date.now() - this.started >= Math.max(5000, this.delay)) this.open();
      }, { signal });
    }
    open(manual = false) {
      if (this.dialog.open || (!manual && this.opened) || document.hidden) return;
      if (!manual && document.querySelector('dialog[open], .drawer[open], .modal[open]')) return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
      this.opened = true;
      this.tab.hidden = true;
      document.documentElement.classList.add('sl-signup-open');
      this.dialog.querySelector('h2')?.focus({ preventScroll:true });
    }
    dismiss() {
      this.dialog.close();
      if (!this.signedUp && !this.preview && !this.editor) {
        this.writeState({ dismissedUntil: Date.now() + Number(this.dataset.dismissDays || 7) * 86400000 });
      }
      this.tab.hidden = this.signedUp;
      if (this.previousFocus instanceof HTMLElement && this.previousFocus !== document.body) this.previousFocus.focus({ preventScroll:true });
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      if (this.dialog?.open) document.documentElement.classList.remove('sl-signup-open');
    }
  }
  customElements.define('savour-signup', SavourSignup);
})();
